import { ArrowUpRight, ShieldCheck } from "lucide-react";
import { HERO_BG, LOGO_URL } from "../lib/data";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative min-h-[92vh] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-navy-deep/95 via-navy/70 to-navy/20" />
      <div className="absolute inset-0 bg-noise" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md text-white/90 text-xs uppercase tracking-[0.22em]">
            <ShieldCheck className="h-3.5 w-3.5 text-safety" />
            ISO-Certified Safety Consulting
          </div>

          <div className="mt-7 flex flex-col gap-5 sm:flex-row sm:items-center">
            <div className="grid h-24 w-24 place-items-center rounded-[1.75rem] border border-white/25 bg-white/95 p-3 shadow-[0_24px_60px_rgba(5,18,36,0.28)] sm:h-28 sm:w-28">
              <img
                src={LOGO_URL}
                alt="Insafe Services logo"
                className="h-full w-full object-contain"
              />
            </div>
            <div>
              <h1
                data-testid="hero-heading"
                className="font-heading text-white text-5xl sm:text-6xl lg:text-7xl font-black leading-[0.9] tracking-tighter"
              >
                Insafe Services
              </h1>
              <p className="mt-3 text-xs sm:text-base uppercase tracking-[0.16em] sm:tracking-[0.3em] text-safety font-semibold whitespace-nowrap">
                Life is precious
              </p>
            </div>
          </div>

          <p className="mt-8 text-lg sm:text-xl text-white/85 max-w-2xl leading-relaxed font-body">
            Helping industries achieve safer workplaces through professional safety audits,
            risk assessments, statutory compliance consulting and certification services —
            since 2018.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-request-audit"
              className="inline-flex items-center gap-2 bg-safety text-white px-7 py-4 rounded-full font-medium btn-lift hover:bg-safety-dark"
            >
              Request Audit <ArrowUpRight className="h-4 w-4" />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-contact"
              className="inline-flex items-center gap-2 bg-white/10 border border-white/30 backdrop-blur-md text-white px-7 py-4 rounded-full font-medium hover:bg-white/20 transition"
            >
              Contact Us
            </a>
          </div>

          <div className="mt-14 flex flex-wrap items-center gap-8 text-white/80 text-sm">
            <Stat value="500+" label="Audits Delivered" />
            <span className="h-8 w-px bg-white/20" />
            <Stat value="20+" label="Years of Expertise" />
            <span className="h-8 w-px bg-white/20" />
            <Stat value="8" label="Industries Served" />
          </div>
        </div>
      </div>

      {/* bottom marker */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/60 text-[10px] tracking-[0.3em] uppercase">
        Scroll
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-heading text-3xl font-bold text-white">{value}</div>
      <div className="text-xs uppercase tracking-widest text-white/70 mt-1">{label}</div>
    </div>
  );
}
